import React from 'react'
import Analytics from './analytics'

export default function withTracker(WrappedComponent, options = {}) {
  const trackPage = page => {
    Analytics.pageview({
      page,
      title: document.title,
      ...options
    })
  }
  const HOC = class extends React.Component {
    componentDidMount() {
      trackPage(this.props.location.pathname)
    }
    componentDidUpdate(prevProps) {
      const currentPage = this.props.pathname
      const prevPage = prevProps.pathname
      if (currentPage !== prevPage) {
        trackPage(currentPage)
      }
    }
    render () {
      return <WrappedComponent {...this.props} />
    }
  }
  return HOC
}



// WEBPACK FOOTER //
// ./src/lib/withTracker.js